import { USER_AUTH_COOKIE_KEY } from '~/lib/constants/cookies'
import { useUserStore } from '~/stores/user'

export default defineNuxtPlugin(async () => {
  const userStore = useUserStore()
  const clientCookieService = useClientCookieService()
  const eventService = useEventService()
  const userService = useUserService()

  try {
    const tokenDetails = clientCookieService.get(USER_AUTH_COOKIE_KEY)

    if (!tokenDetails) {
      return
    }

    clientCookieService.delete(USER_AUTH_COOKIE_KEY)
    clientCookieService.set(USER_AUTH_COOKIE_KEY, tokenDetails, clientCookieService.getSecureCookieDetails())

    // fetchUser writes the user store; fetchUserEvents writes the events store.
    // Both authenticate via the token interceptor (cookie/token store), so they
    // are independent and safe to run in parallel.
    await Promise.all([userService.fetchUser(), eventService.fetchUserEvents()])
  } catch (error) {
    // Render logged-out for this session, but only drop the auth cookie on a
    // real auth rejection. A transient failure (network/5xx) keeps the cookie so
    // the next load can recover instead of forcing a hard logout.
    userStore.setUser(null)

    if (error?.response?.status === 401) {
      clientCookieService.delete(USER_AUTH_COOKIE_KEY)
    }
  } finally {
    userStore.setIsInitialized(true)
  }
})
